export var CurrencyCodeMap = Object.freeze({
  USD: 'USD',
  JPY: 'JPY'
});
export var CurrencyCodeToLocaleMap = Object.freeze({
  USD: 'en-us',
  JPY: 'ja-jp'
});
export var formatPrice = function formatPrice(amount, currencyCode) {
  return amount.toLocaleString(CurrencyCodeToLocaleMap[currencyCode], {
    style: 'currency',
    currency: CurrencyCodeMap[currencyCode]
  });
};